import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as t}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as o}from"../../icon-registry.js";const a=o("solana",t`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            static
        >
            <path
                d="M17.1291 9.53211C17.0898 9.57512 17.0407 9.60857 16.9867 9.62769C16.9327 9.65158 16.8739 9.66114 16.815 9.66114H5.69839C5.30575 9.66114 5.10453 9.18324 5.37937 8.89651L7.20514 7.00881C7.2444 6.9658 7.29348 6.93235 7.35238 6.90845C7.40637 6.88456 7.46526 6.875 7.52416 6.875H18.6849C19.0824 6.875 19.2788 7.35768 18.999 7.64441L17.1291 9.53211ZM17.1291 17.9718C17.0456 18.053 16.9327 18.1008 16.815 18.1008H5.69839C5.30575 18.1008 5.10453 17.6325 5.37937 17.3553L7.20514 15.5106C7.2444 15.4676 7.29839 15.4341 7.35238 15.415C7.40637 15.3911 7.46526 15.3816 7.52416 15.3816H18.6849C19.0824 15.3816 19.2788 15.8547 18.999 16.1319L17.1291 17.9718ZM17.1291 11.2573C17.0456 11.1761 16.9327 11.1283 16.815 11.1283H5.69839C5.30575 11.1283 5.10453 11.5966 5.37937 11.8738L7.20514 13.7185C7.2444 13.7615 7.29839 13.795 7.35238 13.8141C7.40637 13.838 7.46526 13.8475 7.52416 13.8475H18.6849C19.0824 13.8475 19.2788 13.3744 18.999 13.0972L17.1291 11.2573Z"
                fill="url(#paint0_linear_5844_422)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_5844_422"
                    x1="6.10105"
                    y1="18.2409"
                    x2="17.9301"
                    y2="6.41345"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#CF41E8" />
                    <stop offset="1" stop-color="#10F2B0" />
                </linearGradient>
            </defs>
        </svg>
    `);export{a as Solana};
